import React from "react";
import { INoSubLimitBannerProps } from "./NoSubLimitBanner.types";
import { useScrollPosition } from "@n8tb1t/use-scroll-position";
import { Image } from "react-bootstrap";
import {
  PopupTip,
  subscribeDataChange,
  unsubscribeDataChange,
  useFlowData,
} from "@adaptis/flow-components";
import { tips } from "../PopupTips/tips";
import _ from "lodash";
import "./NoSubLimitBanner.scss";

export default function NoSubLimitBanner(props: INoSubLimitBannerProps) {
  const ref = React.useRef<any>();
  const [hideOnScroll, setHideOnScroll] = React.useState(false);
  const [petType, setPetType] = React.useState("dog");
  const { setData, getData } = useFlowData();

  const pets = getData("pets") ?? undefined;

  useScrollPosition(
    ({ currPos }) => {
      const hide = currPos.y >= 1;
      if (hide !== hideOnScroll) setHideOnScroll(hide);
    },
    [hideOnScroll],
    undefined,
    true,
    1
  );

  function handlePetTypeChanged(
    dataPath: string,
    dataField: string,
    data: any
  ) {
    if (dataField == "PetTypeChosenFirst") {
      setPetType(data);
    }
  }

  function onClickGetStarted() {
    console.log("PPP-159", ref);
    window.scrollTo({
      behavior: "smooth",
      top: ref.current.offsetHeight + 100,
    });
  }

  React.useEffect(() => {
    // Anything in here is fired on component mount.
    subscribeDataChange("SelectedPetType", handlePetTypeChanged);

    return () => {
      // Anything in here is fired on component unmount.
      unsubscribeDataChange("SelectedPetType");
    };
  }, []);

  const tip = props.details.tipName
    ? _.get(tips, props.details.tipName)
    : undefined;

  return (
    <div
      data-testid="NoSubLimitBanner"
      ref={ref}
      className={`${
        hideOnScroll
          ? "flc_no-sub-limit-banner z-index-0"
          : "flc_no-sub-limit-banner"
      } ${!petType || petType === "dog" ? "dog" : "cat"}`}
    >
      <div className="sublimit-container">
        <div className="fiftyup-logo">
          <img src="/images/petsy-fiftyup-logo.png" />
        </div>
        <div className="banner-container">
          <div className="left-column">
            <div className="banner-text">
              Want someone to help pay your unexpected vet bills? Petsy Can.
            </div>
            <div className="banner-image">
              <img src="/images/petsy-fiftyup-banner.png" />
            </div>
            <div className="banner-button">
              <button
                className="btn btn-primary"
                onClick={() => {
                  onClickGetStarted();
                }}
              >
                Get Started
              </button>
            </div>
          </div>
          <div className="right-column">
            <div className="awards">
              <img src="/images/petsy-fiftyup-awards.png" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
